export const MB_LIMIT = 5;
enum CSV_FILE_SIZE_LIMITS {
  MAX_CSV_FILE_SIZE = 1024 * 1024 * MB_LIMIT,
}

export default CSV_FILE_SIZE_LIMITS;
